export const isObject = (value: unknown): value is Record<string, any> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const flattenObjects = (obj: Record<string, any>): any[] =>
  Object.values(obj).flatMap((value) =>
    Array.isArray(value)
      ? value // Keep arrays as they are (don't deconstruct dicts inside)
      : typeof value === 'object' && value !== null
        ? flattenObjects(value) // Recursively flatten nested objects
        : value
  );

export const sortByOrder = (entries: [string, any][]) =>
  entries.sort(([, a], [, b]) => {
    const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
    const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });

export const parseStructureFromJSON = (value: string) => {
  try {
    const parsed = JSON.parse(value);
    return parsed;
  } catch (e) {
    return false;
  }
};
